const inBrowser = typeof window !== 'undefined';

const UA = inBrowser ? window.navigator.userAgent.toLowerCase() : '';

const toString = Object.prototype.toString;

const map = {
  '[object Boolean]': 'boolean',
  '[object Number]': 'number',
  '[object String]': 'string',
  '[object Function]': 'function',
  '[object Array]': 'array',
  '[object Date]': 'date',
  '[object RegExp]': 'regExp',
  '[object Undefined]': 'undefined',
  '[object Null]': 'null',
  '[object Object]': 'object',
  '[object HTMLBodyElement]': 'element'
};

const Type = {
  is: function(sub, main) {
    return sub instanceof main;
  },

  isActiveArray: function(v) {
    return this.isArray(v) && v.length > 0;
  },

  isUndef: function(v) {
    return v == null || typeof v == 'undefined';
  },

  isEmpty: function(v) {
    return this.isUndef(v) || v == '';
  },

  isFalse: function(v) {
    return this.isEmpty(v) || isFalse == false;
  },

  UA: UA,

  isIE: UA && /msie|trident/.test(UA),

  isIE9: UA && UA.indexOf('msie 9.0') > 0,

  isEdge: UA && UA.indexOf('edge/') > 0,

  isAndroid: (UA && UA.indexOf('android') > 0),

  isIOS: (UA && /iphone|ipad|ipod|ios/.test(UA)),

  isChrome: UA && /chrome\/\d+/.test(UA) && UA.indexOf('edge/') == -1,

  isFF: UA && UA.indexOf("firefox") > -1,

  isWx: UA && UA.indexOf("MicroMessenger") > -1,

  isDingDing: UA && UA.indexOf("Ding Talk") > -1,
  
  isBaidu: UA && UA.indexOf("baidubrowser") > -1
};

function type(v) {
  return map[toString.call(v)];
}

Object.keys(map).map(key => {
  let name = `is${map[key].match(/^./)[0].toUpperCase()}${map[key].slice(1)}`;
  Type[name] = function(v) {
    return type(v) == map[key];
  }
});

module.exports = Type;

